export type MerchantCountryCode = 'US' | 'CA';

// Forward's hard surcharge cap by merchant processing plan country.
// CA is not enforced yet as there is no merchant/processing-plan lookup wired up
// to determine a merchant's country, so every caller defaults to 'US' for now.
const CREDIT_CARD_FEE_CAPS: Record<MerchantCountryCode, number> = {
    US: 3.0,
    CA: 2.4,
};

export const getCreditCardFeeCap = (countryCode: MerchantCountryCode = 'US'): number => {
    return CREDIT_CARD_FEE_CAPS[countryCode];
};
